import styled from 'styled-components';

import colors from '../../../../../styles/colors';

const CalendarWrapper = styled.div`
  overflow: auto;
  padding: 20px;
  
  .fc-toolbar-title, .fc-icon{
    font-size: 1rem !important;
  }
  .fc-button{
    line-height: 1 !important;
    margin: 5px;
  }
  .fc-toolbar {
    margin-bottom: 0.5em !important;
  }
  .fc-media-screen {
    background: ${colors.shades.secondary7};
    padding: 10px;
    height: 100%;
  }
  .fc-day-past {
    background: ${colors.shades.secondary5};
  }
  .fc-daygrid-day-events {
    display: flex;
    flex-direction: column;
    max-height: 66px;
    overflow-x: hidden;
    margin-bottom: 2px;
    position: absolute;
    bottom: 0;
    min-height: 0 !important;
  }
  .fc-daygrid-day-number{
    width: 100%;
    height: 35px;
  }
  .fc-daygrid-day-events::-webkit-scrollbar {
    width: 5px;
  }
  .fc-daygrid-day-events::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  .fc-daygrid-day-events::-webkit-scrollbar-thumb {
    background: #888;
  }
  .fc-daygrid-day-events::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

const ScheduledBannerContainer = styled.div`
  background-color: ${colors.shades.warning1};
  border: 1px solid ${colors.shades.primary3};
  border-radius: 4px;
  padding: 12px 16px;
  margin: 16px 20px 8px 20px;
  color: ${colors.shades.dark2};
`;

const ScheduledRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 0;
  font-size: 12px;
  border-top: 1px solid ${colors.shades.primary3};

  &:first-of-type {
    border-top: none;
  }
`;

const ScheduledRowIcon = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.shades.gamma10};
`;

const ScheduledRowMessage = styled.span`
  flex: 1;
`;

const ScheduledRowName = styled.span`
  font-weight: 600;
`;

const ScheduledRowType = styled.span`
  background-color: ${colors.shades.primary3};
  border-radius: 3px;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: 500;
  text-transform: capitalize;
`;

const OnHoldBadge = styled.span`
  background-color: ${colors.shades.danger3};
  color: white;
  border-radius: 3px;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-left: 6px;
`;

const ScheduledRowTime = styled.span`
  color: ${colors.shades.gamma10};
  font-size: 11px;
  white-space: nowrap;
`;

const ScheduledDeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  color: ${colors.shades.gamma10};
  display: flex;
  align-items: center;

  &:hover {
    color: ${colors.shades.danger3};
  }
`;

const CalendarControlsRow = styled.div`
  display: flex;
  align-items: center;
  padding: 0 20px;

  .MuiFormControlLabel-label {
    font-size: 12px;
    color: ${colors.shades.gamma10};
  }
`;

export {
  CalendarWrapper,
  CalendarControlsRow,
  ScheduledBannerContainer,
  ScheduledRow,
  ScheduledRowIcon,
  ScheduledRowMessage,
  ScheduledRowName,
  ScheduledRowType,
  ScheduledRowTime,
  ScheduledDeleteButton,
  OnHoldBadge,
};
